import { Error } from '@shared/icons';
import type { IconProps } from '@shared/icons/types';
import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';

type NoResultsProps = Omit<ComponentProps<'div'>, 'title'> & {
  title: string;
  description: string;
  icon?: React.ComponentType<IconProps>;
};

function NoResults({ title, description, icon = Error, className, ...props }: NoResultsProps) {
  const IconComponent = icon as React.ComponentType<IconProps>;

  return (
    <div className={twMerge('flex flex-col gap-4 items-center px-4 py-10 text-center', className)} data-track-name="No Results" {...props}>
      <IconComponent className="size-16 text-foreground-subtle" />
      <h5 className="heading-5">{title}</h5>
      <p className="paragraph text-foreground-subtle">{description}</p>
    </div>
  );
}

export { NoResults };
